<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">Lista de Declaraciones</h4>
        <div class="row">

          <div v-if="rol!=4" class="col-md-4">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>

          <div class="col-md-4">
            <label>Año</label><br>
            <el-select clearable class="select-default" filterable name="periodo" placeholder="Periodo" v-model="model.periodo">
              <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <label></label><br>

            <div style="text-align:left">
              <button @click="getDeclaracionesR" class="btn btn-fill btn-success ">
                Buscar
              </button>
            </div>
          </div>
        </div>

        <div v-if="list_cumplimiento.length >0">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Resumen de declaraciones</h5>
              <div v-for="e in list_cumplimiento">
                <p class="datos"><strong>{{e.tipo_declaracion}}</strong> {{group1k(e.count)}}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Seleccionar una dependencia y un año</h5>
            </div>
          </div>
        </div>


      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {
    Table,
    TableColumn,
    Select,
    Option
  } from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  /*   Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
   */

  export default {
    components: {
      PPagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        model: {
          tipo_declaracion: '',
          dependencia_id: '',
          periodo: '2020'
        },
        rol: '',
        filter: null,
        currentPage: 1,
        dependencias: {},
        perPage: 50,
        periodos: [],
        rows: null,
        tiposDeclaracion: [],
        list_cumplimiento: {},

        filtro_usuarios: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Id',
          value: 'id',
          align: 'center',
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Nombre',
          value: 'nombres',
          align: 'center',
        }, {
          text: 'Dependencia',
          value: 'entidad',
          align: 'center',
        }, {
          text: 'Correo Laboral',
          value: 'correo',
          align: 'center',
        }, ],

        propsToSearch: ['rfc', 'nombres'],
        tableColumns: [{
            prop: 'id',
            label: 'Dec',
            minWidth: 150,
            vif: false
          },
          {
            prop: 'rfc',
            label: 'RFC',
            minWidth: 150,
            vif: true
          },
          {
            prop: 'nombres',
            label: 'Nombre',
            minWidth: 100,
            vif: true
          }
        ]
      }
    },
    computed: {
      pagedData() {
        return this.list_cumplimiento.slice(this.from, this.to)
      },
      queriedData() {
        if (!this.searchQuery) {
          this.pagination.total = this.list_cumplimiento.length
          return this.pagedData
        }
        let result = this.list_cumplimiento
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_cumplimiento.length);
        this.rows = this.list_cumplimiento.length;

        return this.list_cumplimiento.length;
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
      },
      checkPermissions() {
        let permiso = [1];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();

        }
      },

      getTipoDeclaracion() {
        var v = this;
        this.$http.get("tiposDeclaracion").then(
          response => {
            this.tiposDeclaracion = response.data.tipoDeclaracion;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            this.periodos = response.data.periodos;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getDeclaracionesR() {
        this.$http.post("ldeclaracionesrep", this.model).then(
          response => {
            //this.list_cumplimiento = {}
            this.list_cumplimiento = response.data.declarantes;
          },
          error => {
            this.StepError(error);
          }
        );
        /* } */


      },
      getDependencias() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            this.dependencias.unshift({
              'codigo': 'T',
              'id': 0,
              'valor': 'Todas'
            });
          },
          error => {
            this.StepError(error);
          }
        );
      },
    },
    created() {
      this.model.periodo = new Date().getFullYear();
      this.getDependencias();
      this.getTipoDeclaracion();
      this.getPeriodos();
      this.rol = this.getKey('role');
      this.checkPermissions()
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/RepDeclaraciones.vue